module.exports = __webpack_public_path__ + "img/one-page-plan.c7e6354a.svg";